import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  Stack,
  useMediaQuery,
  useTheme,
  Fade,
  Divider,
  Box,
} from '@mui/material';
import { Button } from '@/components/Button/Button';
import { TLifeEventType } from '@/types/ProfileBuilder/profileBuilder';
import { useFiltersOpened } from '@/components/AppPageLayout/CommunityPageLayout/FiltersOpenedContext';
import { VisibilityInfo } from '../../hooks/useLifeEventVisibility';

type Props = {
  lifeEventsSorted: TLifeEventType[];
  visibilityInfo: VisibilityInfo;
  setItemVisibility: (id: string, val: boolean) => void;
};

const LifeEvents = ({
  lifeEventsSorted,
  visibilityInfo,
  setItemVisibility,
}: Props) => {
  const theme = useTheme();
  const filtersOpened = useFiltersOpened();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile && !filtersOpened) return null;

  return (
    <Fade in timeout={1000}>
      <Box>
        {isMobile && <Divider />}
        <Stack
          direction="row"
          flexWrap="wrap"
          gap={theme.spacing(2)}
          mt={{ xs: theme.spacing(3), md: 0 }}
          mb={{ xs: theme.spacing(6), md: theme.spacing(7.5) }}
        >
          {lifeEventsSorted.map((el) => {
            const visible = visibilityInfo[el.id] ?? true;
            return (
              <Button
                small
                variant={visible ? 'contained' : 'outlined'}
                key={el.id}
                onClick={() => setItemVisibility(el.id, !visible)}
              >
                {el.title}
              </Button>
            );
          })}
        </Stack>
      </Box>
    </Fade>
  );
};

export default observer(LifeEvents);
